import { toZonedTime, format } from 'date-fns-tz';
export default function convertDateTime(input) {
  return format(toZonedTime(input, 'Europe/Amsterdam'), `dd/MM/yyyy HH:mm:ss`);
}
